import FingerprintJS from "@fingerprintjs/fingerprintjs";

const DEVICE_KEY = "X_DEVICE_ID";

export async function initDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_KEY);

  if (!deviceId) {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    deviceId = result.visitorId;
    localStorage.setItem(DEVICE_KEY, deviceId);
  }

  return deviceId;
}

export function getDeviceId() {
  return localStorage.getItem(DEVICE_KEY);
}

export function clearDeviceId() {
  localStorage.removeItem(DEVICE_KEY);
}
